import { useQuery } from '@apollo/client';

import {
  getXingJobsDirectorySkillSkillPath,
  getXingJobsSkillSlugPath,
} from '@xing-com/crate-core-routes';
import { MasterDirectoryPopularSkillsDocument } from '@xing-com/crate-master-directory-graphql';

type EntryByLetterParams = {
  jobRole: string;
};

export const useGetPopularSkills = ({
  jobRole,
}: EntryByLetterParams): {
  loading: boolean;
  collection: {
    displayName: string;
    url: string;
    moreUrl: string;
  }[];
} => {
  const { loading, data } = useQuery(MasterDirectoryPopularSkillsDocument, {
    variables: {
      jobRole,
    },
  });

  const collection = (data?.jobsLinkBoxJobRolesRelatedSkills || []).map(
    (skill) => ({
      displayName: skill?.name || '',
      url: getXingJobsSkillSlugPath({ slug: skill?.seoName || '' }),
      moreUrl: getXingJobsDirectorySkillSkillPath({
        skill: skill?.seoName || '',
      }),
    })
  );

  return { loading, collection };
};
